/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForKubernetesClusterOthers extends models.ServiceAccountNativeDetailsBaseForKubernetesCluster {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForKubernetesClusterOthers");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForKubernetesClusterOthers.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForKubernetesClusterOthers>): ServiceAccountNativeDetailsBaseForKubernetesClusterOthers {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForKubernetesClusterOthers(), model);
        ServiceAccountNativeDetailsBaseForKubernetesClusterOthers.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForKubernetesClusterOthers>): ServiceAccountNativeDetailsBaseForKubernetesClusterOthers {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForKubernetesClusterOthers.newInstance(<ServiceAccountNativeDetailsBaseForKubernetesClusterOthers> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForKubernetesClusterOthers) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForKubernetesClusterOthers.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForKubernetesClusterOthers): boolean {
        if (models.ServiceAccountNativeDetailsBaseForKubernetesCluster.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForKubernetesClusterOthers.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
